import { Box, Divider, Stack, Typography } from '@mui/material'
import { FC, useContext } from 'react'

import { CenteredLoading } from '../../components'
import { DviRepairOrderCard } from '../../components/Inspections/DviRepairOrderCard'
import { DviListContext } from '../../providers/DviListProvider/DviListProvider'

const DviHomeActiveJobsList: FC = () => {
  const { isLoading, repairOrderLookup, repairOrderByMeLookup } =
    useContext(DviListContext)
  const hasAssigned = Object.values(repairOrderByMeLookup).length > 0

  return (
    <Stack
      direction="row"
      spacing={1}
      style={{ overflowX: 'scroll', width: '100%' }}>
      {isLoading ? (
        <CenteredLoading />
      ) : !hasAssigned ? (
        <>
          <Box
            minWidth={300}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: 'rgba(0, 0, 0, 0.24)',
              border: '1px dotted black',
              borderRadius: 1
            }}>
            <Typography variant="h3">No Repair Orders Assigned</Typography>
          </Box>
          <Divider orientation="vertical" />
          {Object.values(repairOrderLookup)
            .sort(
              (r1, r2) =>
                r1.repairOrder!.created!.valueOf() -
                r2.repairOrder!.created!.valueOf()
            )
            .map((repairOrder) => (
              <Box key={repairOrder.repairOrder!.id} minWidth={300}>
                <DviRepairOrderCard repairOrder={repairOrder} />
              </Box>
            ))}
        </>
      ) : (
        <>
          {Object.values(repairOrderByMeLookup)
            .sort(
              (r1, r2) =>
                r1.repairOrder!.created!.valueOf() -
                r2.repairOrder!.created!.valueOf()
            )
            .map((repairOrder) => (
              <Box key={repairOrder.repairOrder!.id} minWidth={300}>
                <DviRepairOrderCard repairOrder={repairOrder} />
              </Box>
            ))}
        </>
      )}
    </Stack>
  )
}

export default DviHomeActiveJobsList
